import { render, staticRenderFns } from "./ChatFullscreenItem.vue?vue&type=template&id=174fcb87"
import script from "./ChatFullscreenItem.vue?vue&type=script&lang=js"
export * from "./ChatFullscreenItem.vue?vue&type=script&lang=js"
import style0 from "./ChatFullscreenItem.vue?vue&type=style&index=0&id=174fcb87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports